// import all images and export them as an object
import profileImg from "./profile.jpg";
import ball from "./ball.png";

export const images = {
    profileImg: profileImg,
    ball: ball
} 